import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_HISTOGRAMA_VOLCADORA } from '../../../../config/tables'

export function HistogramaVolcadorasView () {
  return (
    <div style={{ margin: '8px 0' }}>
      <MuiTable id={TABLA_HISTOGRAMA_VOLCADORA} />
    </div>
  )
}
